import { jsx, jsxs } from 'react/jsx-runtime';
import { useContext, useRef, useCallback, Fragment } from 'react';
import { Transition, Dialog, TransitionChild, DialogBackdrop } from '@headlessui/react';
import classNames from 'classnames';
import { ModalContext } from '../Modal.Context/Modal.Context.es.js';

/**
 * Modal Component.
 */ const ModalScreen = ({ children, className, ...rest })=>{
    const { size, open, onCloseEnd, close, disableCloseOutside } = useContext(ModalContext);
    const modalRef = useRef(null);
    const handleClose = useCallback(()=>close(), [
        close
    ]);
    return jsx(Transition, {
        afterLeave: onCloseEnd,
        as: Fragment,
        show: open,
        children: jsx(Dialog, {
            as: "div",
            className: classNames('cb-modal', className),
            initialFocus: modalRef,
            onClose: handleClose,
            open: open,
            static: true,
            ...rest,
            children: jsxs("div", {
                className: "modal-container",
                children: [
                    jsx(TransitionChild, {
                        as: Fragment,
                        enter: "ease-out duration-300",
                        enterFrom: "opacity-0",
                        enterTo: "opacity-100",
                        leave: "ease-in duration-200",
                        leaveFrom: "opacity-100",
                        leaveTo: "opacity-0",
                        children: jsx(DialogBackdrop, {
                            className: classNames('overlay', {
                                'disable-click': disableCloseOutside
                            }),
                            "data-testid": "overlay",
                            onClick: handleClose
                        })
                    }),
                    jsx(TransitionChild, {
                        as: Fragment,
                        enter: "ease-out duration-300",
                        enterFrom: "opacity-0 scale-95",
                        enterTo: "opacity-100 scale-100",
                        leave: "ease-in duration-200",
                        leaveFrom: "opacity-100 scale-100",
                        leaveTo: "opacity-0 scale-95",
                        children: jsx("div", {
                            ref: modalRef,
                            className: classNames(`modal-content`, size),
                            "data-testid": "content",
                            children: children
                        })
                    })
                ]
            })
        })
    });
};
ModalScreen.displayName = 'Modal.Screen';

export { ModalScreen };
//# sourceMappingURL=Modal.Screen.es.js.map
